module.exports = "/images/coastal-flood@3x.png?e14ba2991427bc53c7311860f56bbf8e";